import {Component, NgZone, OnInit, Pipe, PipeTransform} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {NotificationService} from "../../root/toast/notification.service";
import {LoadingWheelService} from "../../root/loading/loading-wheel.service";
import {FormBuilder, FormControl, Validators} from "@angular/forms";
import {ModalService} from "../../root/modal/modal.service";
import {SessionService} from "../../core/session.service";
import {SidebarService} from "../../root/sidebar/sidebar.service";
import {InsuranceService} from "./insurance.service";
import {InsuranceValidationsService} from "./insurance-validations.service";
import {Insurance} from "./insurance";
import {InsuranceDto} from "./insurance-dto";
import {ValidatorService} from "../../core/validator.service";


@Pipe({ name: 'includedFilter' })
export class IncludedPipe implements PipeTransform {
    transform(insurance: any[], included:boolean) {
        return insurance.filter(ins => ins.included == included);
    }
}

@Component({
    selector: 'insurance-edit',
    templateUrl: './insurance-edit.component.html',
    providers: [InsuranceService, InsuranceValidationsService, IncludedPipe]
})
export class InsuranceEditComponent implements OnInit{
    id: any;
    category: string;
    companyOid: number;
    isEditing: boolean;
    errors:any={};
    dto:InsuranceDto=new InsuranceDto();
    categories:String[]=[];
    insurances:Insurance[]=[];
    filterIncluded={included:true};
    filterNotIncluded={included:false};
    errorMessages = {
        'categorySelected': 'common.error.REQUIRED',
        'basesAmount': 'warning.invalidNumberFormat',
        'deductible': 'insurancePrice.REMEMBER_CDW',
        'inputPrice': 'common.error.REQUIRED',
        'deductiblePositive':'ERROR.deducible.valid'
    };
    insuranceForm:any;
    currency:string;
    countryId:string;
    warningOn:boolean=false;
    endLoading:boolean=false;

    INSURANCECODE = 'CDW';
    USACODE = '20208';

    INSURANCELIMIT = 9999999999;
    cdwValid:boolean = true;

    constructor(private  zone: NgZone, private insuranceService: InsuranceService,
                private route: ActivatedRoute, private navigation: Router, private loading: LoadingWheelService,
                private _fb: FormBuilder,  private modalService:ModalService, private sessionService:SessionService,
                private sidebar: SidebarService, private notifications: NotificationService,
                private validator:InsuranceValidationsService) {
        this.sidebar.sidebar = "generalConditions";
    }

    ngOnInit(): void {
        this.bindValidations();
        if(!this.sessionService.getUserSession()){
            this.sessionService.getSubject().subscribe((message) => {
                if(!!message.done){
                    this.bindSessionParameters();
                }
            });
        }else{
            this.bindSessionParameters();
        }

        this.zone.run(() => {
            this.loading.show();
            this.loading.show();
            this.route.params.subscribe(params => {
                this.companyOid = params['companyId'];
                this.category = params['id'];
                this.isEditing = this.category ? this.category != "add" : false;

                this.insuranceService.loadData(this.companyOid).subscribe((response) => {
                    this.insurances = response[1];
                    this.categories = response[0];

                    if (this.isEditing) {
                        this.insuranceService.get(this.companyOid, this.category).subscribe((response) => {
                            this.dto = this.buildInsurancePriceDto(response);
                            this.endLoading=true
                        });
                    }else{
                        this.endLoading = true;
                    }
                    this.loading.hide();
                });
            });
        });
    }

    setWarning() {
        this.warningOn = true;
        setTimeout(function () {
            this.warningOn = false;
        }, 60000);
    }

    private bindSessionParameters() {
        this.countryId = this.sessionService.getUserSession().countryOid;
        if (this.countryId == this.USACODE) {
            this.insuranceForm.registerControl('basesAmount', new FormControl('', Validators
                .compose([this.validInput.bind(this)])));
        }else{
            this.insuranceForm.registerControl('basesAmount', new FormControl('', Validators
                .compose([this.validInput.bind(this)])));
        }
        this.currency = this.sessionService.getUserSession().currencyCode;
    }

    private bindValidations() {
        this.insuranceForm = this._fb.group({
            categorySelected: ['', Validators.required],
            deductible: ['', Validators
                .compose([Validators.required, this.validatePositiveValue.bind(this)])]
        });
    }

    private bindValues() {
        this.insuranceForm.controls['categorySelected'].setValue(this.dto.categoryCode);
        this.insuranceForm.controls['basesAmount'].setValue(this.dto.basesAmount);

        const baseAmountValue = this.dto.basesAmount[this.getCDWId()];
        const deductibleValue = this.dto.deductible[this.getCDWId()];

        //TODO: DSSUP-1421 deductible is always required
        this.insuranceForm.controls['deductible'].setValue(deductibleValue);

        /*this.cdwValid = true;
        if(baseAmountValue){
            this.insuranceForm.registerControl('deductible', new FormControl('', Validators
                .compose([Validators.required, this.validatePositiveValue.bind(this)])));

            this.insuranceForm.controls['deductible'].setValue(deductibleValue);
        }
        else if(!baseAmountValue && deductibleValue && !this.checkCDWIncluded()){
            this.insuranceForm.registerControl('deductible', new FormControl('', Validators
                .compose([this.validatePositiveValue.bind(this)])));
            this.insuranceForm.controls['deductible'].setValue(deductibleValue);
            this.notifications.notifyErrorByCode('common.ERROR_cdwValueMandatory');
            this.cdwValid = false;
        }*/
    }


    public checkCDWIncluded(){
        return !!(this.insurances.find((i) => i.included  && i.code === 'CDW'));
    }

    private getCDWId() {
        return this.insurances.find((i) => i.code === 'CDW').oid;
    }

    public isCDWInsurance(code){
        return code === this.INSURANCECODE;
    }

    private validInput(context: any) {
        const contextValue = context.value;
        const isInputValid = Object.keys(contextValue).every((element) => {
            const input = context.value[element];

            return (!input || (input > 0 && input <= this.INSURANCELIMIT));
        });

        return (!contextValue || isInputValid) ? null : {valid: false};
    }

    private validatePositiveValue(c:any) {
        return (ValidatorService.positiveValue(c) && ValidatorService.lessThanOrEqualTo(c, this.INSURANCELIMIT)) ? null : {
            valid: false
        }
    }

    private hasAnyPriceAdded(c:any) {
        return (!!c.value && (
            (Object.keys(c.value.basesAmount).some((k) => c.value.basesAmount[k] && c.value.basesAmount[k] > 0 )))) ? null : {
            valid: false
        }
    }


    cancel(){
        this.modalService.show("CANCEL_ALERT_TITLE", "CANCEL_ALERT_DESCRIPTION",
            () => this.navigation.navigateByUrl('/company/'+this.companyOid+'/insurancePrice'));
    }

    save(){
        this.errors = [];
        this.bindValues();
        let validations = this.validator.validate(this.insuranceForm);
        if(this.cdwValid) {
            if (validations.valid) {
                this.zone.run(() => {
                    this.insuranceService.saveInsurance(this.dto, this.companyOid, this.isEditing).subscribe((response) => {
                        this.persistCallback(this);
                    });
                })
            } else {
                this.errors = validations.errors;
            }
        }
    }

    private persistCallback(context:any){
        context.notifications.displayToast('insurancePrice.TITLE','insurancePrice.confirmationMessage.SUCCESS_SAVE', null, 'INFO');
        context.navigation.navigateByUrl('/company/'+context.companyOid+'/insurancePrice');
    }

    private buildInsurancePriceDto(response) {
        let basesAmount = {};
        let deductible = {};
        response.forEach((e) => {
            basesAmount[e.insuranceOid]=e.baseAmount;
            deductible[e.insuranceOid]=e.deductible;
        });
        return new InsuranceDto(this.category, basesAmount, deductible);
    }

}



// WEBPACK FOOTER //
// ./public/upgrade/feature/insurance/insurance-edit.component.ts